import React, { Component } from 'react'
import DayPicker from 'react-day-picker'
import moment from 'moment'
import SmoothCollapse from 'react-smooth-collapse'
import enhanceWithClickOutside from 'react-click-outside'
import { connect } from 'react-redux'
import { updateTask } from 'state/actions'
import Icon from 'components/icon/icon'

import copy from 'fast-copy'

import {
	formatTaskDate,
	getPrimaryColumnValue
} from 'utils'

class TaskDates extends Component {
	clickMenu = type => {
		const {
			menuState,
			task,
			openMenu,
			column,
			isDisabled
		} = this.props

		if (isDisabled) {
			return
		}

		if (menuState.currentOpenColumnId === column.id + '_' + type && menuState.currentFocusedTask === task.id) {
			openMenu(null)
		} else {
			if (task) {
				openMenu(column.id + '_' + type, task.id)
			}
		}
	}

	dateObject = dateStr => {
		return new Date(dateStr)
	}

	handleDateChange = (date, type, event) => {
		event.stopPropagation()

		const {
			task,
			openMenu,
			updateTask,
			column
		} = this.props

		const taskDates = (task.column_data && task.column_data[column.id]) ? task.column_data[column.id] : {
			start: null,
			end: null
		}

		const dateMoment = moment(date)

		if (type == 'end' && taskDates.start) {
			const startMoment = moment(taskDates.start)

			if (dateMoment.isBefore(startMoment) && !dateMoment.isSame(startMoment, 'day')) {
				return null
			}
		} else if (type == 'start' && taskDates.end) {
			const endMoment = moment(taskDates.end)

			if (dateMoment.isAfter(moment(taskDates.end)) && !dateMoment.isSame(endMoment, 'day')) {
				return null
			}
		}

		const taskObject = copy(task)

		const newDate = formatTaskDate(date)

		const normalisedType = type.replace('_date', '')

		if (taskDates[normalisedType] !== newDate) {
			taskDates[normalisedType] = newDate
		} else {
			taskDates[normalisedType] = null
		}

		if (this.props.taskActivityHistory) {
			// For Hassl brain. Mostly redundant for now.
			this.props.taskActivityHistory.push({
				activity: 'CHANGE',
				type: 'DATE',
				taskId: task.id,
				targetId: null
			})
		}

		openMenu(null)

		const columnData = taskObject.column_data ? taskObject.column_data : {}
		columnData[column.id] = taskDates

		taskObject.column_data = columnData

		updateTask(taskObject)
	}

	getInitialMonth = type => {
		const {
			task,
			currentProject,
			column
		} = this.props

		const taskDates = getPrimaryColumnValue('date', task, currentProject, column.id)

		switch (type) {
			case 'start':
				if (taskDates.start) {
					return new Date(taskDates.start)
				} else if (taskDates.end) {
					return new Date(taskDates.end)
				}

				break
			case 'end':
				if (taskDates.end) {
					return new Date(taskDates.end)
				} else if (taskDates.start) {
					return new Date(taskDates.start)
				}

				break
		}

		return new Date()
	}

	render() {
		const {
			currentProject,
			task,
			hasGantts,
			menuState,
			isSingle,
			isDisabled,
			column
		} = this.props

		let className = 'task-dates clear'

		this.isOpened = false

		const taskDates = getPrimaryColumnValue('date', task, currentProject, column.id, false, column)

		if (!task || !taskDates || (!taskDates.start && !taskDates.end)) {
			className += ' hidden'
		}

		if (!hasGantts) {
			className += ' single'
		}

		if (task) {
			if (menuState.currentFocusedTask === task.id) {
				if (menuState.currentOpenColumnId && menuState.currentOpenColumnId.toString().startsWith(column.id + '_')) {
					className += ' opened'

					this.isOpened = menuState.currentOpenColumnId.includes('start') ? 'start' : 'end'
				}
			}
		}

		let startDateClass = this.isOpened === 'start' ? 'active' : ''
		let endDateClass = this.isOpened === 'end' ? 'active' : ''

		if (!task || !taskDates || !taskDates.start) {
			startDateClass += ' is-empty'
		}

		if (!task || !taskDates || !taskDates.end) {
			endDateClass += ' is-empty'
		}

		if (isDisabled) {
			className += ' disabled'
		}

		return (
			<div className={className} onClick={e => e.stopPropagation()}>
				{
					hasGantts ?
						<a
							href="javascript:void(0)"
							onClick={_ => { this.clickMenu('start') }}
							className={startDateClass}
						>
							<span className="date-label">
								{isSingle &&
									<Icon name="fe-calendar" />
								}
								{task && taskDates.start ?
									moment(taskDates.start).add(task.recurrenceDeltaDays || 0, 'days').format('D MMM')
									: 'Start'
								}
							</span>
							<div className="task-menu-container" onClick={e => { e.stopPropagation() }}>
								{
									task ?
										<SmoothCollapse
											heightTransition="0.15s ease"
											expanded={this.isOpened == 'start'}
											className="task-menu-collapse"
										>
											<DayPicker
												isOpened={this.isOpened == 'start'}
												firstDayOfWeek={1}
												onDayClick={(day, modifiers, e) => this.handleDateChange(day, 'start', e)}
												selectedDays={new Date(taskDates.start)}
												initialMonth={this.getInitialMonth('start')}
												disabledDays={taskDates.end ? {
													after: new Date(taskDates.end)
												} : null}
											/>
										</SmoothCollapse>
										: null
								}
							</div>
						</a>
						: null
				}
				{
					(hasGantts && !isSingle) ?
						<em>
							&ndash;
						</em>
						: null
				}
				<a
					href="javascript:void(0)"
					onClick={_ => { this.clickMenu('end') }}
					className={endDateClass}
				>
					<span className="date-label">
						{isSingle &&
							<Icon name="fe-calendar" />
						}
						{task && taskDates && taskDates.end ?
							moment(taskDates.end).add(task.recurrenceDeltaDays || 0, 'days').format('D MMM')
							:
							hasGantts ? 'End' : '(None)'
						}
					</span>
					<div className="task-menu-container" onClick={e => { e.stopPropagation() }}>
						{
							task ?
								<SmoothCollapse
									heightTransition="0.15s ease"
									expanded={this.isOpened == 'end'}
									className="task-menu-collapse"
								>
									<DayPicker
										isOpened={this.isOpened == 'end'}
										firstDayOfWeek={1}
										onDayClick={(day, modifiers, e) => this.handleDateChange(day, 'end', e)}
										selectedDays={new Date(taskDates ? taskDates.end : null)}
										initialMonth={this.getInitialMonth('end')}
										disabledDays={taskDates && taskDates.start ? {
											before: new Date(taskDates.start)
										} : null}
									/>
								</SmoothCollapse>
								: null
						}
					</div>
				</a>
			</div>
		);
	}

}

export default enhanceWithClickOutside(connect(null, { updateTask })(TaskDates))
